(function () {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('download-battery-results', {
                parent: 'app',
                url: '/download-battery-results',
                data: {
                    authorities: ['ROLE_STAFF', 'ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_BILLER'],
                    pageTitle: 'global.menu.entities.downloadBatteryResults'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/download-battery-results/download-battery-results.html',
                        controller: 'DownloadBatteryResultController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('downloadResult');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
